<template>
    <a
        class="uk-link-heading"
        v-on="$listeners"
    >
        <div
            class="quick-filter-button"
            :style="[ selected ? { color: color } : '']"
        >
            {{ label }}
        </div>
    </a>
</template>

<script>

export default {
    props: {
        label: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        color: {
            type: String,
            default: () => {
                return "#faa05a";
            }
        }
    }
}
</script>

<style lang="scss">

@import "~uikit/src/scss/variables-theme.scss";

.quick-filter-button {
    border-style: solid;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 500px;
    font-size: 0.875rem;
    background: #FFFFFF;
    height: 22px;
    min-width: 22px;
    align-items: center;
    display: inline-flex;
    box-sizing: border-box;
    vertical-align: middle;
    justify-content: center;
    -webkit-box-align: center;
    border-width: thin;
}

</style>